// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"ae335f4a","284":"b11b198d","470":"ca62bf75","835":"e70ea24f","894":"7a6d469d","920":"707d0779"}[chunkId] + ".chunk.css";
};